import * as Colors from '@pkg/utils/colors';
import * as Obj from '@pkg/utils/objects';
import { TagSource } from '@/lib/enums';

/**
 * @param {Object} tags
 * @return {Object}
 */
export default function deriveProps(tags, categories) {
  if (Obj.isEmpty(tags)) {
    return [];
  }

  const keyed = {};
  const derived = {
    categories: [],
    tags: [],
  };

  categories.map((item) => {
    const category = structuredClone(item);
    category.__color = Colors.tag({ color: category.color, state: null });
    category.__source = category.is_system
      ? TagSource.SYSTEM
      : TagSource.CUSTOM;
    category.__taggables_set = new Set(item.taggables);
    derived.categories.push(category);
    keyed[category.uuid] = category;
  });

  tags.forEach((item) => {
    const tag = structuredClone(item);
    tag.__category = keyed[tag.category_uuid] ?? null;
    tag.__color = Colors.tag({ color: tag.color, state: null });
    tag.__source = tag.is_system ? TagSource.SYSTEM : TagSource.CUSTOM;
    tag.__taggables_set = new Set(tag.taggables);
    derived.tags.push(tag);
  });

  return derived;
}
